import {createRouter, createWebHistory} from 'vue-router'
import {userAuthenticate} from "@/functions/userAuthenticate";
import {brandConfigMap} from "../brand";
import {utagDataPost} from "@/functions/utagDataPost";

const routes = [
    {
        path: '/',
        redirect: getBaseRoute(),
    },
    {
        path: '/landing',
        name: 'LandingPage',
        component: () => import("@/views/pages/LandingPage"),
    },
    {
        path: '/question-screen',
        name: 'QuestionScreen',
        component: () => import("@/views/pages/QuestionScreen"),
    },
    {
        path: '/leaderboard',
        name: 'LeaderboardScreen',
        component: () => import("@/views/pages/LeaderboardScreen"),
    },
    {
        path: '/game-complete',
        name: 'GameCompletedPage',
        component: () => import("@/views/pages/GameCompletedPage"),
    },
    {
        path: '/game-fail',
        name: 'GameFailPage',
        component: () => import("@/views/pages/GameFailPage"),
    },
    {
        path: '/rewards',
        name: 'RewardsPage',
        component: () => import("@/views/pages/RewardsPage"),
    },
    {
        path: '/menu',
        name: 'MenuPage',
        component: () => import("@/views/pages/MenuPage.vue"),
    },
    {
        path: '/how-to-play',
        name: 'HowToPlay',
        component: () => import('@/views/components/howToPlay.vue'),
    },
    {
        path: '/my-profile',
        name: 'MyProfile',
        component: () => import('@/views/pages/myProfile.vue'),
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
})

function getBaseRoute(){
    const domain = window.origin;
    const brandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');
    return brandConfig.baseRoute;
}

router.beforeEach(async (to, from, next) => {
    await userAuthenticate(to, from, next);
})

router.afterEach((to, from, next) => utagDataPost(to, from, next));

export default router
